<template>
    <div class="sealList">
        <div class="seal_title">
            <div class="title">
                Ukey管理
            </div>
            <span style="color: red;">注：用户可以将普通云章转换为含有Ukey介质的Ukey电子印章，只需购买Ukey介质，请根据你的需求选择</span>
        </div>
        <div class="seal_message">
            <div class="for" v-for="(item,index) in sealList" :key="index">

                <div style="border: solid 1px #aaaaaa;">

                    <div style="height:30px;line-height:30px;border-bottom:1px #ddd solid"> {{item.signatureName}} </div>
                    <div class="img">
                        <img :src=" $global.Local+ item.stampTemplate"/>
                        <!-- <img :src="'data:image/png;base64,'+ item.stampTemplateBase64"/> -->
                    </div>

                     
                    <div class="zhang-btn" v-if=" item.isUkey == 0 ">
                      
                        <div class="btn1" style="width: 100%;
                           background-color:#109ee7 "
                             @click="handlApplyUkey(item)">
                            购买Ukey介质
                        </div>
                    </div>

                    <div class="zhang-btn" v-else-if="item.isFinsh == 1" >
                        <div class="btn1"  style="width: 100%;"  >
                            Ukey已制作完成
                        </div>
                    </div>
                    <div class="zhang-btn" v-else >
                        <div class="btn1"  style="width: 100%;"  >
                            Ukey制作中......
                        </div>
                    </div>

                </div>
                <!--        -->
                <div class="zheG" v-show="item.state == 0">
                    审核中
                </div>
                <div class="sinType">

                </div>
                <div class="text">{{ item.signType == 1 ? '个人' : '企业' }}</div>

            </div>
        </div>



        <el-dialog :visible.sync="dialogShowFlag" width="50%" center  title="" >
            <div>

                <el-form   ref="ukeyUserForm" :rules="rules" :model="dataForm"  label-width="120px"  >
                        <el-form-item label="收件人" prop="ukeyUserName">
                            <el-input v-model="dataForm.ukeyUserName"  placeholder="请输入收件人姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="收件人联系电话"  prop="ukeyUserPhone">
                            <el-input v-model="dataForm.ukeyUserPhone" maxlength="11" placeholder="请输入收件人联系电话"></el-input>
                        </el-form-item>
                        <el-form-item  label="收件地址"  prop="ukeyUserAddress">
                            <el-input v-model="dataForm.ukeyUserAddress"  placeholder="请输入收件地址"></el-input>
                        </el-form-item>
                </el-form>



            </div>
            <span slot="footer" class="dialog-footer">
                <el-button  type="primary" @click="submitUkeyApply">提交</el-button>
                <el-button @click="dialogShowFlag = false">取 消</el-button>
              </span>
        </el-dialog>




    </div>
</template>

<script>
    export default {
        data() {
            return {
                sealDialogVisible: false,
                options: [{
                    value: '选项1',
                    label: '个人印章'
                }, {
                    value: '选项2',
                    label: '企业印章'
                }],
                value: '',
                sealList: [],

                dialogShowFlag:false,
                dataForm:{
                    signatureId:'',
                    ukeyUserName:'',
                    ukeyUserPhone:'',
                    ukeyUserAddress:'',
                },
                rules: {
                    ukeyUserName:[{
                        required: true,
                        message: '请输入收货人姓名',
                        trigger: 'blur'
                    }],
                    ukeyUserPhone:[{
                        required: true,
                        message: '请输入收货人电话号码',
                        trigger: 'blur'
                    }, {
                        pattern:/^1[3456789]\d{9}$/,
                        message:"请输入正确的手机号码",
                        trigger:"blur",
                    }],
                    ukeyUserAddress:[{
                        required: true,
                        message: '请输入收货人详细地址',
                        trigger: 'blur'
                    }]
                }

            }
        },
        mounted() {
            this.getData();
        },
        methods: {


            handlApplyUkey(item) {
                this.dataForm = {
                    signatureId: item.id ,
                    ukeyUserName:'',
                    ukeyUserPhone:'',
                    ukeyUserAddress:'',
                };
                this.dialogShowFlag = true;
            },

            submitUkeyApply(){
                this.$refs.ukeyUserForm.validate(valid => {
                    if(valid){

                        // 对象信息封装转化为  FormData
                        let formData = new FormData();
                        Object.keys( this.dataForm ).forEach((value, key) => {
                            formData.append(value ,this.dataForm[value] );
                        })

                        this.api.addUkeyApply(  formData ).then(res => {
                            this.dialogShowFlag = false;
                            this.$message.success('UKey申请成功，请在订单列表进行支付');
                            // this.getData();

                            this.$router.push({
                                name: 'payUkey',
                                params:  {id:  this.dataForm.signatureId , type: 1 }
                            });


                        })


                    }
                })
            },

            getUkeyPayState( item ){
                if( item.paySuccess ==1 ){
                    return "支付完成";
                }else if(  item.paySuccess == 0  ){
                    return "Ukey待支付";
                }else if(  item.paySuccess == 2  ){
                    return "Ukey订单失败";
                }else{
                    return "";
                }

            },
            toUkeyOrder( item ){
                console.log(item);
                // 跳转至Ukey支付页面
                let _this = this;
                if( item.paySuccess ==1 ){
                    _this.$message.success('该印章Ukey已支付，可正常使用');
                    return  ;
                }else if( item.state != '1' ){
                    _this.$message.error('该印章未通过审核，请耐心等待');
                    return  ;
                }else if(   item.state == '1'  &&  item.paySuccess == 0 ){
                    _this.$router.push({
                        name: 'payUkey',
                        params:  item
                    });
                }
            },


            getData() {
                let _this = this;

                let param = new FormData();
                param.append('token', this.$global.token);
                // 【API请求】----获取可申请的Ukey列表  getMyCertList   getUkeyList
                _this.api.getUkeyList(param).then(res => {
                    _this.sealList = res.data;
                    console.log(res);
                })
            },

        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    #sealDialog /deep/ .el-dialog {
        background-color: #ffffff;
        border-radius: 30px;
        border: solid 1px #aaaaaa;
        width: 35% !important;

        .all {
            width: auto;
            height: auto;
            display: flex;
            justify-content: center;

            .perSeal {
                width: 240px;
                height: 240px;
                background-image: linear-gradient(270deg,
                #1e6eee 0%,
                #109ee7 50%,
                #01cee0 100%),
                linear-gradient(#000000,
                #000000);
                background-blend-mode: normal,
                normal;
                box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                letter-spacing: 2px;
                color: #ffffff;
                @column();

                img {
                    width: 66px;
                    height: 62px;
                    margin-bottom: 33px;
                    object-fit: cover;
                }
            }

            .entSeal {
                width: 240px;
                height: 240px;
                background-image: linear-gradient(270deg,
                #1e6eee 0%,
                #109ee7 50%,
                #01cee0 100%),
                linear-gradient(#000000,
                #000000);
                background-blend-mode: normal,
                normal;
                box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                margin-left: 40px;
                letter-spacing: 2px;
                color: #ffffff;
                cursor: pointer;
                @column();

                img {
                    width: 66px;
                    height: 62px;
                    margin-bottom: 33px;
                    object-fit: cover;
                }
            }
        }
    }

    .sealList {
        width: @a;
        height: auto;
        margin-left: 4%;

        .seal_title {
            width: 1090px;
            height: 40px;
            display: flex;
            align-items: center;

            .title {
                width: 150px;
                height: auto;
                font-family: MicrosoftYaHei-Bold;
                font-size: 24px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
            }

            .btn {
                width: 150px;
                height: 40px;
                background-image: linear-gradient(270deg,
                #1e6eee 0%,
                #109ee7 50%,
                #01cee0 100%),
                linear-gradient(#000000,
                #000000);
                background-blend-mode: normal,
                normal;
                letter-spacing: 1px;
                color: #ffffff;
                line-height: 40px;
                text-align: center;
                margin-left: 23px;
                cursor: pointer;
                font-size: 16px;
            }

            .select {
                width: 245px;
                height: 40px;
                margin-left: 550px;
            }
        }

        .seal_message {
            width: @a;
            height: auto;

            .for:nth-child(4n+1) {
                margin-left: 0;
            }

            .for {
                width: auto;
                height: auto;
                background-color: #ffffff;
                display: inline-block;
                margin-left: 35px;
                margin-top: 30px;
                position: relative;

                .ukey {
                    width: 40px;
                    height: 40px;
                    position: absolute;
                    top: -10px;
                    left: -10px;
                    @row();
                    border-radius: 50%;
                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#ffffff,
                    #ffffff);
                    background-blend-mode: normal,
                    normal;
                    box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                    color: #fff;
                }

                .zheG {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 80%;
                    background: #000;
                    opacity: 0.8;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .sinType {
                    width: 60px;
                    height: 60px;
                    position: absolute;
                    top: 0px;
                    right: 0px;
                    @row();
                    border-top: 50px solid #f2f2f2;
                    border-left: 70px solid transparent;

                }

                .endDay {
                    width: 100%;
                    font-size: 18px;
                    color: #333333;
                    height: auto;
                    text-align: center;
                    margin-top: 20px;
                }

                .text {
                    position: absolute;
                    top: 5px;
                    right: 5px;
                    color: red;

                }

                .img {
                    width: 244px;
                    height: 140px;
                    background-color: #ffffff;

                    img {
                        width: @a;
                        height: @a;
                        object-fit: contain;
                    }
                }

                .zhang-btn {
                    width: 100%;
                    height: auto;
                    display: flex;
                    justify-content: space-between;

                    .btn1 {
                        width: 50%;
                        height: 46px;
                        background-color: #f5f5f5;
                        line-height: 46px;
                        text-align: center;
                        letter-spacing: 1px;
                        color: #333333;
                        cursor: pointer;
                        border-bottom: solid 1px #aaaaaa;
                        border-right: solid 1px #aaaaaa;
                        font-size: 18px;
                    }

                    .btn2 {
                        width: 50%;
                        height: 46px;
                        background-color: #f5f5f5;
                        line-height: 46px;
                        text-align: center;
                        letter-spacing: 1px;
                        color: #333333;
                        cursor: pointer;
                        border-bottom: solid 1px #aaaaaa;
                        font-size: 18px;
                    }
                }

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/seal/ukeyList.vue